export default {
  title: "Renommer l'offre",
  subtitle: 'Saisissez un nouveau nom pour votre offre (40 caractères maximum)',
  toasts: {
    success: 'Offre renommée avec succès',
    error: "Échec du renommage de l'offre",
  },
  buttons: {
    rename: 'Renommer',
  },
  form: {
    title: {
      label: "Nom de l'offre",
      placeholder: "Saisir le nom de l'offre",
    },
  },
};
